<template>
  <div id="contents">
    <div class="recruit_rorando">
      <div class="recruit_rorando_main">
        <div class="title_area">
           <p class="title">俺とテレビ朝日映像</p>
        </div>
        <div @click="close" class="back_btn_icon">
          <img src="../assets/img/common/recruit_2021/close.png" alt="close">
        </div>
        <div class="main_image">
          <img src="../assets/img/common/recruit_2021/rorando/main.png" />
        </div>
         <p class="caption" >2018年、「ソノサキ」の取材で出会ったことから始まった、ローランドさんとテレビ朝日映像のお付き合い。現在は、当社の「TAPキャスト」がマネジメントを行っています。そんなローランドさんに、質問！</p>
        <div class="impression">
          <div class="text_area">
            <h3>Ｑ.テレビ朝日映像の印象は？</h3>
            <p>単刀直入に言うと、「見る目あるな」。ローランドを発掘したのって、テレビ朝日映像じゃないですか。先見の明があるってこと。俺の中では評価高いっすよ。</p>
          </div>
          <div class="image_area">
            <img src="../assets/img/common/recruit_2021/rorando/impression.png" />
          </div>
        </div>
        <div class="memories">
          <div class="text_area">
            <h3>Ｑ.一番印象的な思い出や</h3><h3>出来事は？</h3>
            <p>ロケも収録もたくさんしましたね。寒暖差が激しい東京ーモンゴルのロケ帰り、トランジットのミスでスタッフたちと硬いベンチで一晩明かしたことも。飛行機も普段はビジネス以下は乗らないのに、この時はLCC。座席の角度は80度ぐらいだった気がする（笑）。一番印象に残ってるのは、「ソノサキ」最終回でスタジオにサプライズ出演した時。足音を立てないように俺の靴の裏にフェルトを貼ったんだけど、まさか27歳にもなって靴裏にフェルトとは…。番組の演出を一番に考えてこんなことをするのもテレビ朝日映像のスタッフならではって感じ。</p>
          </div>
        </div>
        <div class="difference">
          <div class="text_area">
            <h3>Ｑ.他社（がつくった番組）</h3>
            <h3>との違いは？ </h3>
            <p>リアル感が違いますよね。バラエティってもっと面白くつくるのかなと思ってたんだけど、密着取材ではガチの姿を撮られてた。人を怒る時も、カメラが回ってればカメラを意識すると思うんだけど、密着取材ではそんなことなくて、真剣に何かを伝えている姿や本当に憤ってる姿がそのまま撮られてた。スタッフは空気になるぐらい、その場に自然に溶け込んでたと思う。</p>
          </div>
          <div class="image_area">
            <img src="../assets/img/common/recruit_2021/rorando/difference.png" />
          </div>
        </div>
        <div class="message">
          <div class="text_area">
            <h3>Ｑ.テレビ朝日映像にメッセージを！</h3>
            <p>俺は勝負の世界に生きてきて、「勝とう」と思って勝ったことは一度もない。「No.1になろう」と思ってなったわけじゃない。まず、お客さまを楽しませることを第一に考えて、気がついたらNo.1になってた。テレビも同じじゃないですか？視聴者や作り手自身が面白いと思うものをつくっていけばいいと思います。まだまだ伸びしろもセンスもあるし、期待してますよ。辛くなったら、うちの店（THE CLUB）においで。テレビ朝日映像って言ってくれればサービスしますよ、料金は２割増しだけど（笑）。</p>
          </div>
        </div>
        <div class="profile">
          <div class="image_area">
            <img src="../assets/img/common/recruit_2021/rorando/profile.png"/>
          </div>
          <div class="text_area">
            <h3>ローランド</h3>
            <img src="../assets/img/common/recruit_2021/rorando/pink_line.png"/>
            <p>1992年、東京都生まれ。高校卒業後すぐに大学を中退し、18歳でホストデビュー。1年間の下積みを経て、歌舞伎町の数々の最年少記録を更新し、「現代ホスト界の帝王」と称される。現在はホストクラブ経営の他に、タレントや実業家、投資家など多方面で活躍中。</p>
          </div>
        </div>
      </div>
      <div class="footer"></div>
    </div>
  </div><!-- #contents -->
</template>
<script>
export default {
  name: 'recruit_rorandoo',
  data() {
    return {
      request_id: null,
      loading: false,
      post_list: null,
      error: null,
    }
  },
  props: [
    'post_type'
  ],
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  },
  methods: {
    close(){
      this.$emit('close_icon');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  #contents
    width: 100vw
  .recruit_rorando
    &_main
      width: 79.8vw
      margin: calc(36.1vw - 41px) auto 0
      padding: 44px 5.6vw 45px
      background-color: #fff
      position: relative
      .title_area
        position: absolute
        top: -25px
        left: 21px
        .title
          @include recruit_font(26px, 20px, .176em)
          color: #02ACC3
          background: #FFF500
          padding: 11px 3px 13px 9px
          display: table
      .caption
        @include recruit_font(12px, 23px, 1.5px)
        display: block
        width: 297px
        height: 131px
        margin: 187px auto 21px
      .back_btn_icon
        position: absolute
        top: -78px
        left: 0vw
        img
          width: 32px
          height: 32px
      .main_image
        width: 297px
        height: 187px
        margin: 0px auto 12px
        position: absolute
        top: 37px
        img
          width: 100%
      .impression
        margin: 0px auto 52px
        position: relative
        .text_area
          h3
            @include recruit_font(20px, 40px, .094em)
            display: inline-block
            color: #02ACC3
            background-color: #FFF500
            padding-left: 4px
            position: absolute
            top: 0px
            left: calc( -20vw / 2)
          p
            @include recruit_font(12px, 23px, .124em)
            margin: 61px 0 0
            width: 297px
            height: 101px
            display: inline-block
        .image_area
          img
            width: 297px
            height: 198px
            margin: 0 auto
      .memories
        position: relative
        margin: 0 auto 52px
        .text_area
          h3
            display: inline-block
            color: #02ACC3
            background-color: #FFF500
            margin-bottom: 21px
            padding: 0 4px
            position: absolute
            left: calc( -20vw / 2)
            &:first-child
              @include recruit_font(20px, 40px, .094em)
              padding: 0 4px 0 4px
            &:not(:first-child)
              @include recruit_font(20px, 20px, .094em)
              height: 32px
              padding: 3px 0px 0 4px
              top: 40px
          p
            @include recruit_font(12px, 23px, .124em)
            display: inline-block
            width: 297px
            height: 279px
            margin-top: 92px
      .difference
        position: relative
        margin: 0 auto 55px
        .text_area
          h3
            display: inline-block
            color: #02ACC3
            background-color: #FFF500
            padding: 0 4px
            position: absolute
            left: calc( -20vw / 2)
            &:first-child
              @include recruit_font(20px, 40px, .094em)
              padding: 0 0px 0 4px
            &:not(:first-child)
              @include recruit_font(20px, 20px, .094em)
              height: 32px
              padding: 3px 0px 0 4px
              top: 40px
          p
            @include recruit_font(12px, 23px, .124em)
            width: 297px
            display: inline-block
            margin-top: 92px
        .image_area
          margin-top: 24px
          img
            width: 297px
            height: 184px
      .message
        position: relative
        margin: 0 auto 39px
        .text_area
          h3
            @include recruit_font(20px, 40px, .094em)
            display: inline-block
            color: #02ACC3
            background-color: #FFF500
            margin-bottom: 21px
            padding: 0 4px
            width: 96vw
            position: absolute
            left: calc( -20vw / 2)
          p
            @include recruit_font(12px, 23px, .124em)
            display: inline-block
            width: 297px
            height: 258px
            margin-top: 60px
      .profile
        margin: 0 auto
        .image_area
          margin-right: 40px
          img
            width: 131px
            height: 131px
            
        .text_area
          h3
            @include recruit_font(22px, 22px, .206em)
            display: inline-block
            margin: 16px 0px 13px
            color: #FF7689
          img
            width: 297px
            height: 3px
            margin-bottom: 12px
            display: block
          p
            @include recruit_font(12px, 20px, .107em)
            display: inline-block
            width: 297px
    .footer
      padding-bottom: 80px
  @media screen and (max-width: 374px)
    .recruit_rorando
      &_main
        margin: calc(39.1vw - 41px) auto 0
        padding: 40px 5.6vw 45px
        .title_area
          .title
            @include recruit_font(22px, 20px, .176em)
            padding: 9px 3px 11px 9px
        .caption
          width: 79.8vw
          height: auto
          margin: 49vw auto 13.6vw
        .back_btn_icon
          img
        .main_image
          width: 79.8vw
          height: auto
          position: absolute
          top: 8.9vw
          img
        .impression
          .text_area
            h3
              @include recruit_font(17px, 34px, .094em)
            p
              width: 79.8vw
              height: auto
              margin: 16.3vw 0 3.3vw
          .image_area
            img
              width: 79.8vw
              height: auto
        .memories
          .text_area
            h3
              &:first-child
                @include recruit_font(17px, 34px, .094em)
              &:not(:first-child)
                @include recruit_font(17px, 17px, .094em)
                height: 26px
                padding: 3px 0px 0 4px
                top: 34px
            p
              width: 79.8vw
              height: auto
              margin-top: 24.5vw
        .difference
          margin: 0 auto 14.7vw
          .text_area
            h3
              &:first-child
                @include recruit_font(17px, 34px, .094em)
              &:not(:first-child)
                @include recruit_font(17px, 17px, .094em)
                height: 26px
                padding: 3px 0px 0 4px
                top: 34px
            p
              width: 79.8vw
              height: auto
              margin-top: 24.5vw
          .image_area
            margin-top: 6.4vw
            img
              width: 79.8vw
              height: auto
        .message
          .text_area
            h3
              @include recruit_font(17px, 34px, .094em)
            p
              width: 79.8vw
              height: auto
              margin-top: 16vw
        .profile
          .image_area
            img
          .text_area
            h3
            img
              width: 79.8vw
              height: auto
            p
              width: 79.8vw
      .footer
</style>



// WEBPACK FOOTER //
// src/components/recruit_rorando.vue